"use strict";import{tag as a}from"../custom-tag.js";export function dodecaStarIcon({height:t=16,width:r=16,hidden:e=!1,title:l="Dodeca star"}={}){return a`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${r}
      height=${t}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${e?"true":"false"}"
      role="img"
      aria-label="${l}"
    >
      <path
        fill="currentColor"
        d="M24 12.002c0 .991-1.962 1.711-2.206 2.625-.252.946 1.079 2.548.6 3.377-.478.83-2.544.484-3.225 1.165-.682.68-.326 2.738-1.165 3.225-.838.487-2.43-.853-3.377-.6-.913.244-1.63 2.206-2.623 2.206s-1.716-1.965-2.625-2.207c-.946-.252-2.548 1.08-3.377.601-.83-.478-.485-2.544-1.165-3.225-.68-.682-2.739-.326-3.224-1.165-.486-.838.852-2.43.6-3.377C1.968 13.713 0 12.997 0 12.002c0-.994 1.962-1.71 2.213-2.623.252-.946-1.08-2.548-.6-3.377.48-.83 2.543-.485 3.224-1.165s.326-2.74 1.165-3.225c.838-.486 2.43.852 3.377.6C10.293 1.969 11.009 0 12.004 0c.994 0 1.71 1.962 2.623 2.213.946.252 2.548-1.08 3.377-.601.83.478.484 2.544 1.165 3.225.68.681 2.74.326 3.225 1.165.486.838-.852 2.43-.6 3.377.244.914 2.206 1.633 2.206 2.623"
      />
    </svg>
  `}
//# sourceMappingURL=dodecaStar.js.map
